import { View } from '@react-pdf/renderer';
import type { ReactElement } from 'react';

import { PdfImage, type PdfImageProps } from './PdfImage';
import { PdfTextBlock, type PdfTextBlockProps } from './PdfTextBlock';

export type PdfHeaderProps = {
  content?: PdfTextBlockProps;
  image?: PdfImageProps;
};

export const PdfHeader = ({ content, image }: PdfHeaderProps): ReactElement => (
  <View fixed>
    {image !== undefined && <PdfImage {...image} />}
    {content !== undefined && <PdfTextBlock {...content} />}
  </View>
);
